export class ClinicalCaseSurveyOption {
  public id: string;
  public description?: string;
  public order: number;
  public token: string;
  public removed: boolean;
  public votes: number;
  public percent: number;
}
